import type React from 'react';
import type { ActiveAnnouncement, AnnouncementUiComponent } from '@chatsdet/types';
import { InterstitialAnnouncementDialog } from './InterstitialAnnouncementDialog';

export interface AnnouncementComponentProps {
  announcement: ActiveAnnouncement;
  /** Close + record-nothing-further; the view was already recorded on show. */
  onDismiss: () => void;
}

/**
 * Maps an announcement's `uiComponent` to the React component that renders it.
 * Add a future surface by adding one entry here + one member to
 * `announcementConfigSchema` in `@chatsdet/types`.
 */
export const announcementComponents: Record<
  AnnouncementUiComponent,
  React.ComponentType<AnnouncementComponentProps>
> = {
  interstitial_dialog: InterstitialAnnouncementDialog,
};
